import React, { Component } from 'react';
import classes from "./TextZodiac2.module.css";

export default class TextPersonSpecies extends Component {

    render() {
        // const { data, labels } = this.state;
        return (
            <div className={classes.container}>
                
                <p className="text-anal">A deeper appreciation of the lore behind Astrology and the Zodiac sign makes this game play in Animal Crossing fresh and exciting. Some background context: there are 4 Signs: Air (Gemini, Libra and Aquarius), Earth (Taurus, Virgo and Capricorn), Fire (Aries, Leo and Sagittarius), and Water (Cancer, Scorpio and Pisces). </p>
        
                <p className="text-anal">Legend and myth has it that the Air Sign indicates a person is rational, social, and loves communication and relationships with other people. They love philosophical discussions, social gatherings and good books. Earthy people are grounded and practical, loyal and stable. They stick by their people through hard times. Fiery people are passionate, dynamic, and temperamental; they are intelligent, self-aware, creative, idealistic, and always ready for action. The Water personalities are highly intuitive, and they can be as mysterious as the ocean itself. They love profound conversations and intimacy. People with similar signs or personalities tend to be compatible in relationships-  in friendship and in love. In addition, opposites attract because their different personalities complement the other, such as Air to Fire and Water to Earth.</p> 
                 
            </div>
        )
    }
}

/* Tutorial from:
     https://blog.bitsrc.io/customizing-chart-js-in-react-2199fa81530a
*/